import React, { useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { useState } from "react";
import UploadLoader from "./UploadLoader";
import axios from "axios";
import { MapKey, url } from "../../Data/Data";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TadobaContext from "../Context/TadobaContext";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import {
  GoogleMap,
  Marker,
  Polygon,
  LoadScriptNext,
} from "@react-google-maps/api";
import { warningToaster, successToaster } from "../../Data/Data";
import { makeRequest } from "../../api";
const WeeklyUpload = ({ file, setFile }) => {
  const navigate = useNavigate();
  const [error, setError] = useState(true);
  const [position, setPosition] = useState(null);
  const [id, setId] = useState(null);
  const api = useContext(TadobaContext);

  const [polygonCoordinates, setPolygonCoordinates] = useState([]);
  const [defaultYear, setDefaultYear] = useState(api.defaultYear);

  const [rangeList, setRangeList] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const [beatList, setBeatList] = useState([]);
  const [compartmentList, setCompartmentList] = useState([]);
  const [stationList, setStationList] = useState([]);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [cameraName, setCameraName] = useState("");

  const [selectedRange, setSelectedRange] = useState(null);
  const [selectedRound, setSelectedRound] = useState(null);
  const [selectedBeat, setSelectedBeat] = useState(null);
  const [selectedCompartment, setSelectedCompartment] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);
  const [locationType, setLocationType] = useState("");

  const isDisabled =
    !latitude ||
    !longitude ||
    !cameraName ||
    !selectedRange ||
    !selectedRound ||
    !selectedBeat ||
    !selectedCompartment ||
    !selectedStation;

  const generateRandomKey = () => {
    const length = 6;
    let key = "";
    const characters = "0123456789";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      const randomChar = characters.charAt(randomIndex);
      key += randomChar;
    }

    return key;
  };
  // sample commit for deployment

  const uploadAllImages = (imageFiles) => {
    const batchSize = 25;
    const batches = [];
    let images_data = [];
    let totalUploaded = 0;
    let randomKey = generateRandomKey();
    let totalUploadedSize = 0;
    let fileList = imageFiles;
    const baseUrl = `${url}api/v1/classification/image_upload_weekly/`;
    for (let i = 0; i < fileList.length; i++) {
      const url = fileList[i];
      totalUploadedSize += url.size;
    }

    api.setProgress({
      ...api.progress,
      totalImages: fileList.length,
      totalUpload: totalUploadedSize,
    });
    localStorage.setItem("upload_token", randomKey);
    api.setUploadKey(randomKey);

    for (let i = 0; i < imageFiles.length; i += batchSize) {
      const batch = imageFiles.slice(i, i + batchSize);
      batches.push(batch);
    }

    const processBatch = async (count, list, batchNumber, totalImages) => {
      let shift = 0;
      if (batches.length === 0) {
        api.setImages(list);
        api.setUpload(false);
        navigate("./upload_images");
        api.setProgress({
          uploadPercentage: 0,
          totalUpload: 0,
          completeUpload: 0,
        });
        return true;
      }

      const batch = batches.shift();
      let formData = new FormData();
      formData.append("lat", latitude);
      formData.append("long", longitude);
      formData.append("upload_token", localStorage.getItem("upload_token"));
      formData.append("batch_number", batchNumber);
      formData.append("total_images", totalImages);
      formData.append("camera_id", id);
      formData.append("year", defaultYear);
      formData.append("location_type", locationType);
      formData.append("range_id", selectedRange);
      formData.append("round_id", selectedRound);
      formData.append("beat_id", selectedBeat);
      formData.append("compartment_id", selectedCompartment);
      formData.append("station_id", selectedStation);
      formData.append("camera_name_weekly", cameraName);

      for (const key of Object.keys(batch)) {
        formData.append(
          "files",
          new File(
            [batch[key], "extra data: " + batch[key].path],
            batch[key].name,
            { type: batch[key].type }
          )
        );
      }

      let token = "";
      let csrftoken = "";
      api.setUpload(true);
      try {
        if (localStorage.token) {
          token = localStorage.token;
        }
        if (localStorage.csrf) {
          csrftoken = localStorage.csrf;
        }
        let loadedData;
        const result = await axios({
          url: baseUrl,
          withCredentials: true,
          method: "post",
          headers: {
            "Content-Type": "multipart/form-data",
            TADOBAAUTH: token,
            "X-CSRFToken": csrftoken,
          },
          data: formData,
          onUploadProgress: (progressEvent) => {
            let { loaded, total } = progressEvent;
            loadedData = Math.floor(
              (progressEvent.loaded * file.length) / progressEvent.total
            );
            shift = total;
            let percent = Math.floor(
              ((count + loaded) / totalUploadedSize) * 100
            );
            api.setProgress({
              totalUpload: totalUploadedSize,
              uploadPercentage: percent,
              completeUpload: count + loaded,
              completedImages: loadedData,
              totalImages: file.length,
            });
          },
        });
        list = [...list, ...result.data.data];
      } catch (error) {
        api.setUpload(false);
        setLongitude("");
        setLatitude("");
        setPosition(null);
        setError(true);
        toast.success("Unable to Upload", warningToaster);
        return false;
      }
      processBatch(count + shift, list, batchNumber + 1, totalImages);
    };
    processBatch(totalUploaded, images_data, 1, imageFiles.length);
  };

  const fetchPolygon = async () => {
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest("get", `api/v1/map/map_borders/`);
      const convertedData = result.data.data.map(({ latitude, longitude }) => ({
        lat: latitude,
        lng: longitude,
      }));
      setPolygonCoordinates(convertedData);
    } catch (error) {}
  };
  useEffect(() => {
    if (!localStorage.mapborders) {
      fetchPolygon();
    } else {
      const storedData = JSON.parse(localStorage.mapborders);
      setPolygonCoordinates(storedData);
    }
  }, []);

  const uploadHandler = () => {
    uploadAllImages(file);
  };

  const cancelHandler = () => {
    setFile([]);
  };

  useEffect(() => {
    const fetchRanges = async () => {
      let token = "";
      try {
        if (localStorage.token) {
          token = localStorage.token;
        }
        const result = await makeRequest("get", `api/v1/map/range_list/`);
        setRangeList(result.data.data);
      } catch (error) {}
    };
    fetchRanges();
  }, []);

  const fetchRounds = async (id) => {
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/map/round_list/?id=${id}`
      );
      setRoundList(result.data.data);
    } catch (error) {}
  };

  const fetchBeats = async (id) => {
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest("get", `api/v1/map/beat_list/?id=${id}`);
      setBeatList(result.data.data);
    } catch (error) {}
  };

  const fetchCompartments = async (id) => {
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/map/compartment_list/?id=${id}`
      );
      setCompartmentList(result.data.data);
    } catch (error) {}
  };

  const fetchStations = async (id) => {
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/map/station_list/?id=${id}`
      );
      setStationList(result.data.data);
    } catch (error) {}
  };

  const handleMarkerDragEnd = (e) => {
    setLatitude(e.latLng.lat());
    setLongitude(e.latLng.lng());
    setPosition({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  };

  useEffect(() => {
    if (latitude && longitude) {
      setPosition({
        lat: Number(latitude),
        lng: Number(longitude),
      });
    }
  }, [latitude, longitude]);

  const rangeChangeHandler = (event) => {
    const selectedId = event.target.value;
    const selectedName =
      event.target.options[event.target.selectedIndex].getAttribute(
        "data-name"
      );

    // Reset all children filters
    setSelectedRound(null);
    setSelectedBeat(null);
    setSelectedCompartment(null);
    setSelectedStation(null);

    setSelectedRange(selectedId);
    setLocationType(selectedName);

    fetchRounds(selectedId);
  };

  const roundChangeHandler = (event) => {
    const selectedId = event.target.value;

    setSelectedBeat(null);
    setSelectedCompartment(null);
    setSelectedStation(null);

    setSelectedRound(selectedId);

    fetchBeats(selectedId);
  };

  const beatChangeHandler = (event) => {
    const selectedId = event.target.value;

    setSelectedCompartment(null);
    setSelectedStation(null);

    setSelectedBeat(selectedId);

    fetchCompartments(selectedId);
  };

  const compartmentChangeHandler = (event) => {
    const selectedId = event.target.value;

    setSelectedStation(null);

    setSelectedCompartment(selectedId);

    fetchStations(selectedId);
  };

  return (
    <div className="Upload">
      <div className="UploadProperties">
        {api.upload ? (
          <UploadLoader
            setUpload={api.setUpload}
            percent={api.progress.uploadPercentage}
            total={api.progress.totalUpload}
            complete={api.progress.completeUpload}
            totalImages={api.progress.totalImages}
            completedImages={api.progress.completedImages}
            data={"Uploading Images..."}
            type={"general"}
          />
        ) : (
          <>
            <div className="UploadPropertiesHeading">
              <span>Assign Geolocation</span>
            </div>
            <div className="UploadFields">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="UploadImagesGroup">
                  <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
                    <img
                      src={file[0].preview}
                      style={{ borderRadius: "8px 8px 0px 0px" }}
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      src={file[1]?.preview}
                      style={{ borderRadius: "0px 0px 0px 8px" }}
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      src={file[2]?.preview}
                      style={{ borderRadius: "0px 0px 8px 0px" }}
                      alt=""
                    />
                  </div>
                </div>
                <div className="uploadimagdesc">
                  <span>Images</span>
                  <span style={{ color: "#9A938A" }}>({file.length})</span>
                </div>
              </div>
              <div className="UploadMapProperties">
                <div style={{ height: "100%", width: "100%" }}>
                  <LoadScriptNext googleMapsApiKey={MapKey}>
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={
                        position === null
                          ? { lat: 21.572004, lng: 79.19164 }
                          : position
                      }
                      // onClick={handleMarkerDragEnd}
                      zoom={9}
                    >
                      <Polygon
                        paths={polygonCoordinates}
                        options={{
                          fillColor: "skyblue",
                          fillOpacity: 0.4,
                          strokeColor: "blue",
                          strokeOpacity: 0.6,
                          strokeWeight: 2,
                        }}
                      />
                      {position === null ? (
                        ""
                      ) : (
                        <Marker
                          position={position}
                          draggable={true}
                          onDragEnd={handleMarkerDragEnd}
                        />
                      )}
                    </GoogleMap>
                  </LoadScriptNext>
                </div>
              </div>
              <div className="UploadParameters">
                <div className="UploadLocations">
                  <div className="DirectionDropdown">
                    <label htmlFor="camera">Camera</label>
                    <input
                      id="camera"
                      name="camera"
                      value={cameraName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 4) {
                          setCameraName(value);
                        }
                      }}
                      placeholder="Camera Name"
                      maxLength={4}
                    />
                  </div>

                  <div className="DirectionDropdown">
                    <label htmlFor="">Latitude</label>
                    <input
                      name=""
                      value={latitude}
                      onChange={(e) => setLatitude(e.target.value)}
                      placeholder="Latitude"
                      type="number"
                      id=""
                    />
                  </div>
                  <div className="DirectionDropdown">
                    <label htmlFor="">Longitude</label>
                    <input
                      name=""
                      value={longitude}
                      onChange={(e) => setLongitude(e.target.value)}
                      placeholder="Longitude"
                      type="number"
                      id=""
                    />
                  </div>
                </div>
                <div className="UploadLocations">
                  <div className="DirectionDropdown">
                    <label htmlFor="">Location type</label>
                    <select
                      onChange={rangeChangeHandler}
                      value={selectedRange || ""}
                      required
                    >
                      <option disabled hidden value="">
                        Select or Type Location
                      </option>
                      {rangeList.map((value) => (
                        <option
                          key={value.id}
                          value={value.id}
                          data-name={value.name}
                        >
                          {value.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="DirectionDropdown">
                    <label htmlFor="">Select Round</label>
                    <select
                      onChange={roundChangeHandler}
                      value={selectedRound || ""}
                      required
                    >
                      <option disabled hidden value="">
                        Select or Type Round
                      </option>
                      {roundList.map((value) => (
                        <option key={value.id} value={value.id}>
                          {value.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="DirectionDropdown">
                    <label htmlFor="">Select Beat</label>
                    <select
                      onChange={beatChangeHandler}
                      value={selectedBeat || ""}
                      required
                    >
                      <option disabled hidden value="">
                        Select or Type Beat
                      </option>
                      {beatList.map((value) => (
                        <option key={value.id} value={value.id}>
                          {value.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="DirectionDropdown">
                    <label htmlFor="">Select Compartment</label>
                    <select
                      onChange={compartmentChangeHandler}
                      value={selectedCompartment || ""}
                      required
                    >
                      <option disabled hidden value="">
                        Select or Type Compartment
                      </option>
                      {compartmentList.map((value) => (
                        <option key={value.id} value={value.id}>
                          {value.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="DirectionDropdown">
                    <label htmlFor="station">Station</label>
                    <input
                      id="station"
                      name="station"
                      value={selectedStation}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 4) {
                          setSelectedStation(value);
                        }
                      }}
                      placeholder="Station Name"
                      maxLength={4}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="WeeklyButtons UploadPropertiesButton">
              <div onClick={cancelHandler} className="Cancel_button">
                <span>Cancel</span>
              </div>
              <div
                onClick={uploadHandler}
                disabled={isDisabled}
                className={`Upload_button ${
                  isDisabled ? "upload_disabled" : ""
                }`}
              >
                <span>Upload</span>
              </div>
            </div>
          </>
        )}
      </div>
      <ToastContainer rtl={false} style={{ height: "10px" }} />
    </div>
  );
};

export default WeeklyUpload;
